import type { CheckboxGroupProps, FieldProps } from '@hover/blueprint';
import { CheckboxGroup, Field, Flex, forwardRef } from '@hover/blueprint';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface CheckboxGroupFieldProps
  extends Omit<FieldProps, 'children' | 'variant' | 'size'>,
    Pick<CheckboxGroupProps, 'size'> {}

export const CheckboxGroupField = forwardRef<CheckboxGroupFieldProps, 'input'>(
  ({ children, defaultValue, name, ...props }, ref) => {
    const { control, errors } = useFormContext<Record<string, string>>();
    const error = errors[name]?.message;

    return (
      <Field
        defaultValue={defaultValue}
        error={error}
        name={name}
        testid="checkbox-group"
        {...props}
      >
        <Controller
          control={control}
          name={name}
          render={({ onChange, value = [] }) => (
            <Flex display="flex" gap="400" ref={ref}>
              <CheckboxGroup onChange={onChange} value={value as string[]}>
                {children}
              </CheckboxGroup>
            </Flex>
          )}
        />
      </Field>
    );
  },
);
